import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import { Provider } from "react-redux";

import { extendTheme } from "@chakra-ui/react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./Routes";
import store from "./Store/store";

const theme = extendTheme({
  colors: {
    primary: {
      50: "#FFF3E0",
      100: "#FFE0B2",
      200: "#FFCC80",
      300: "#FFB74D",
      400: "#FFA726",
      500: "white", // principal (laranja queimado)
      600: "#9C5E0D",
      700: "#2f2a2a",
      800: "#282c55",
      900: "#141414",
    },
    green: {
      50: "#e6f7e6",
      100: "#b3e6b3",
      200: "#80d680",
      300: "#4dcc4d",
      400: "#26b326",
      500: "#1a8a1a",
      600: "#146614",
      700: "#0f4f0f",
      800: "#0a3a0a",
      900: "#052205",
    },
    background: "black",
    secundary: "black",
  },

  components: {
    Button: {
      baseStyle: {
        bg: "primary",
        color: "secundary",
        _hover: {
          bg: "secundary",
          color: "primary",
        },
      },
    },

    IconButton: {
      defaultProps: {
        variant: "solid",
        colorScheme: "primary",
      },
      baseStyle: {
        bg: "primary",
        color: "blue",
        _hover: {
          bg: "primary",
        },
      },
    },
  },

  styles: {
    global: {
      body: {
        bg: "linear-gradient(to bottom, rgba(24, 23, 23, 0.993), rgb(7, 7, 7))",
        color: "primary.500",
      },
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <ChakraProvider theme={theme}>
        <Router>
          <AppRoutes />
        </Router>
      </ChakraProvider>
    </React.StrictMode>
  </Provider>
);
